<script>
import { getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'CheckMore',
  props: {
    mode: {
      type: String,
      default: '0' // 0: w215 h41  1: w215 h94  2: w420 h40
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getPageThemeColor,
    sizeMode(modeId) {
      return `mode-${modeId}`
    }
  }
}
</script>

<template>
  <div
    class="check-more"
    :class="sizeMode(mode)"
    :style="{backgroundColor: getPageThemeColor(path, 0.1)}"
  >
    <p class="check-text" :style="{color: getPageThemeColor(path)}">查看更多<i class="el-icon-arrow-right" /></p>
  </div>
</template>

<style lang="scss" scoped>
.check-more {
  border-radius: 5px;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  .check-text {
    font-size: 13px;
    font-weight: bold;
    i {
      font-weight: bold;
    }
  }
}
.mode-0 {
  width: 215px;
  height: 41px;
}
.mode-1 {
  width: 215px;
  height: 94px;
}
.mode-2 {
  width: 420px;
  height: 40px;
}
</style>
